// Scripts
import "./scripts/tooltips_handler";
import "./scripts/fie_upload_handler";
// import "./scripts/price_calculator_handler";
import "./scripts/submit_handler";

// Styles
import "./styles/style.scss";
